import { reactive } from "vue";

export const store = reactive({
	navDropdownHeight: 0,
	navDrawerWidth: 0,
});

export const mutations = {
	changeNavDropdownHeight(newHeight) {
		store.navDropdownHeight = newHeight;
	},
	changeNavDrawerWidth(newWidth) {
		store.navDrawerWidth = newWidth;
	}
};
